export default class VehicleType {
  id = '';
  name = '';
  seatCapacity = 0;
  luggageCapacity = 0;
  safetySeatCapacity = 0;
  price = 0;

  constructor({
    id = '',
    name = '',
    seatCapacity = 0,
    luggageCapacity = 0,
    safetySeatCapacity = 0,
    price = 0,
  } = {}) {
    this.id = id;
    this.name = name;
    this.seatCapacity = seatCapacity;
    this.luggageCapacity = luggageCapacity;
    this.safetySeatCapacity = safetySeatCapacity;
    this.price = price;
  }

  get isValid() {
    return Boolean(this.id && this.name && this.seatCapacity > 0);
  }

  clone() {
    return new VehicleType({
      id: this.id,
      name: this.name,
      seatCapacity: this.seatCapacity,
      luggageCapacity: this.luggageCapacity,
      safetySeatCapacity: this.safetySeatCapacity,
      price: this.price,
    });
  }
}
